export class PromiseWithResolver extends Promise {
    resolve;
}
